export const ROOT_NODE_ID = 'ROOT_NODE_ID';
